import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import logo from '../../assets/images/logo.png'
import shellShuanShim from '../../assets/images/shellshuanshim.jpg'

class Header extends Component {
  render() {
    return (
      <>
        <div className="ch-header" id="home">
          <div className="ch-header-box">
            <FontAwesomeIcon icon="clock" />
            <span>08:00 - 16:00</span>
          </div>
          <div className="ch-header-box">
            <FontAwesomeIcon icon="phone" />
            <span>02-190-6090 / 081-806-2929</span>
          </div>
        </div>
        <div className="ch-brand">
          <div className="container-lg p-0 d-flex">
            <div className="d-flex align-items-center">
              <img src={logo} alt="chefhung-logo" />
              <h1 className="ch-brand-name display-3">
                <span>Chef</span> Hung
              </h1>
            </div>
            <div className="ch-brand-shellshuanshim">
              <img className="img-fluid ml-4" src={shellShuanShim} alt="เชลล์ชวนชิม" />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Header
